import {useEffect, useState} from "react"

const Number = (props) => {
    const {name, value, label, className, isReady, error, required, suffix, onChange, ...rest} = props
    const [inputValue, setInputValue] = useState('')


    const handleChange = (ev) => {
        ev.preventDefault()
        setInputValue(ev.target.value)
        if(typeof onChange === "function"){
            onChange(ev)
        }
    }


    useEffect(() => {
        if(value){
            setInputValue(value)
        }
    }, [value])


    return (
        <div className="form-group">
            <div className="input-container">
                {label && <label>
                    {required && <span className="text-red required">* </span>}
                    {label}
                    {error && <span className="error">{error}</span>}
                </label>
                }
                <input
                    name={name}
                    type="number"
                    value={inputValue}
                    disabled={!isReady}
                    className={`form-control form-control-sm ${className ? className : ''}`}
                    onChange={handleChange}
                    {...rest}
                />
                {suffix && <span className="suffix">{suffix}</span>}
            </div>
        </div>
    )
}

export default Number